"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCourierWebhookEventDto = instanceOfCourierWebhookEventDto;
exports.CourierWebhookEventDtoFromJSON = CourierWebhookEventDtoFromJSON;
exports.CourierWebhookEventDtoFromJSONTyped = CourierWebhookEventDtoFromJSONTyped;
exports.CourierWebhookEventDtoToJSON = CourierWebhookEventDtoToJSON;
exports.CourierWebhookEventDtoToJSONTyped = CourierWebhookEventDtoToJSONTyped;
const CourierWebhookEventData_1 = require("./CourierWebhookEventData");
/**
 * Check if a given object implements the CourierWebhookEventDto interface.
 */
function instanceOfCourierWebhookEventDto(value) {
    return true;
}
function CourierWebhookEventDtoFromJSON(json) {
    return CourierWebhookEventDtoFromJSONTyped(json, false);
}
function CourierWebhookEventDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'] == null ? undefined : json['type'],
        'data': json['data'] == null ? undefined : (0, CourierWebhookEventData_1.CourierWebhookEventDataFromJSON)(json['data']),
    };
}
function CourierWebhookEventDtoToJSON(json) {
    return CourierWebhookEventDtoToJSONTyped(json, false);
}
function CourierWebhookEventDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'data': (0, CourierWebhookEventData_1.CourierWebhookEventDataToJSON)(value['data']),
    };
}
//# sourceMappingURL=CourierWebhookEventDto.js.map